export default __webpack_public_path__ + "static/media/about-oldcoffeebags.48647ab1.jpg";